window.LibraryCompositeHelpers = window.LibraryCompositeHelpers || {
    version: "Library.Composite.Helpers: 2018.06.14.2",
    test: function () {
        return "2018.06.14.5";
    }
};